import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {NestApiProvider} from "../../nest-api";
import {RequestPreviewDto, ResponsePreviewDto} from "../dto/view-absw-report.dto";

@Injectable()
export class ViewAbswReportApi {
  private readonly service: string = '';
  private readonly model: string = 'viewAbswReport';
  private timeout: number = (5 * 60) * 1000;

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public preview(payload: RequestPreviewDto): Observable<ResponsePreviewDto> {
    const method: string = 'POST';
    const func: string = 'preview';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePreviewDto>(method, url, params, urlParams, body, null, this.timeout);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/view-absw-report.api.ts